import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { GlobalBannerDescriptor } from '@/shared/types/banners';

interface Props extends GlobalBannerDescriptor {
  onDismiss: () => void;
}

export const GlobalBanner = ({ message, action, onDismiss }: Props) => {
  const { t } = useTranslation();

  return (
    <Alert
      variant="urgent"
      role="status"
      className="sticky top-0 z-100 flex items-center justify-center rounded-none p-2 pl-4"
    >
      <AlertDescription className="flex flex-wrap items-center justify-center gap-1 leading-5">
        <span>{message}</span>
        {action?.kind === 'link' && (
          <Link
            to={action.to}
            target={action.external ? '_blank' : undefined}
            rel={action.external ? 'noopener noreferrer' : undefined}
          >
            {action.label}
          </Link>
        )}
        {action?.kind === 'text' && <span>{action.label}</span>}
      </AlertDescription>
      <Button
        variant="ghost-neutral"
        size="icon-xs"
        type="button"
        onClick={onDismiss}
        className="absolute top-3 right-3.5 size-4 text-inherit hover:bg-transparent [&_svg]:text-inherit"
        aria-label={t('common.dismiss')}
      >
        <XIcon size={16} />
      </Button>
    </Alert>
  );
};
